import { useMemorama } from '../../context/MemoramaContext'
import { ExitGameModal, getAvatarSrc } from '@shared'

export default function ExitMemoramaModal ({ onClose, onExit }) {
  const { players, currentTurnIndex } = useMemorama()
  const currentPlayer = players[currentTurnIndex]
  const avatarSrc = getAvatarSrc(currentPlayer.avatar)

  return (
    <ExitGameModal
      onClose={onClose}
      onExit={onExit}
      imageSrc={avatarSrc}
    />
  )
}
